module.exports = __webpack_public_path__ + "static/media/GoudyNational-Italic.1ed5aa9a.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/GoudyNational-Italic.woff
// module id = 2978
// module chunks = 51